import { useTranslation } from 'react-i18next'

import { Icon, Menu } from '@percent/lemonade'
import { EmployeesActionsMenuProps } from './EmployeesActionMenu.types'

export function EmployeesActionsMenu({ handleSelect, items, currency }: EmployeesActionsMenuProps) {
  const { t } = useTranslation()

  return (
    <Menu
      title={<Icon name="menu-vertical" size={6} color={!currency ? 'gray100' : 'neutral300'} />}
      disabled={!currency}
      disabledTooltipMessage={t('toolTip.workplaceGiving.noAction')}
      onSelect={key => handleSelect(key)}
      sections={[{ items }]}
    />
  )
}
